.dropZone,
.selected {
  border-radius: 8px;
  text-align: center;
  cursor: pointer;
}
.dropZone {
  border: 2px dashed var(--dark-border);
  padding: 20px;
}
.selected {
  border: none;
  padding: 0;
}
.file {
  background-color: var(--upload-file-surface);
  padding: 10px;
  border-radius: 8px;
  margin-top: 10px;
}
